import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ReminderIcon = (props: IconProps) => (
  <Icon w="16px" h="16px" viewBox="0 0 16 16" {...props}>
    <path d="M14.667 3.813 11.6 1.24l-.86 1.02 3.067 2.573.86-1.02ZM5.253 2.26 4.4 1.24 1.333 3.807l.86 1.02 3.06-2.567Zm3.08 3.073h-1v4l3.167 1.9.5-.82-2.667-1.58v-3.5ZM8 2.667a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm0 10.666a4.663 4.663 0 0 1-4.667-4.666A4.663 4.663 0 0 1 8 4a4.663 4.663 0 0 1 4.667 4.667A4.663 4.663 0 0 1 8 13.333Z" />
  </Icon>
);

export default memo(ReminderIcon);
